import React from 'react';

function CalendarPage() {
  return <div className="page-container"><h1>Calendar</h1><p>Calendar view coming soon...</p></div>;
}

export default CalendarPage;
